import React from 'react';
import Icon from '../../../components/AppIcon';

const StatusCard = ({ 
  title, 
  status, 
  statusLabel, 
  description, 
  icon,
  onClick 
}) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'excellent':
        return 'text-success bg-success/10';
      case 'good':
        return 'text-success bg-success/10';
      case 'warning':
        return 'text-warning bg-warning/10';
      case 'critical':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'excellent':
        return 'CheckCircle2';
      case 'good':
        return 'CheckCircle2';
      case 'warning':
        return 'AlertTriangle';
      case 'critical':
        return 'AlertCircle';
      default:
        return 'Info';
    }
  };

  return (
    <div 
      className={`bg-card rounded-lg p-4 md:p-6 shadow-sm border border-border transition-smooth hover-lift ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1">
          <p className="text-xs md:text-sm font-caption text-muted-foreground mb-2">
            {title}
          </p>
          <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-md ${getStatusColor(status)}`}>
            <Icon name={getStatusIcon(status)} size={16} />
            <span className="text-sm md:text-base font-medium font-caption">
              {statusLabel}
            </span>
          </div>
        </div>
        {icon && (
          <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-md bg-primary/10">
            <Icon name={icon} size={20} color="var(--color-primary)" />
          </div>
        )}
      </div>
      {description && (
        <p className="text-xs md:text-sm text-muted-foreground font-caption">
          {description}
        </p>
      )}
    </div>
  );
};

export default StatusCard;